import { gql } from "@apollo/client";

const SUBMITTAL_BY_PK = `
  SubmittalSubscription($id: uuid!) {
    submittals_by_pk(id: $id) {
      revision
      submittal_revisions
      ROJ
      assignee
      submittal_assignee {
        email
        first_name
        id
        last_name
        project_users {
          status_id
          subscription_vendor {
            name
          }
          subscription {
            organization_subscriptions {
              organization {
                name
              }
            }
          }
        }
      }
      redirect_url
      created_at
      due_date
      description
      id
      issue_date
      organization
      revision
      spec_section_id
      spec_no
      spec_name
      material_tracking
      submittal_manager
      submittal_manager_user {
        email
        first_name
        id
        last_name
        project_users {
          subscription {
            organization_subscriptions {
              organization {
                name
              }
            }
          }
        }
      }
      received_from
      received_from_user {
        email
        first_name
        last_name
        id
        project_users {
          subscription_vendor {
            name
          }
        }
      }
      status
      workflow_status
      submittals_status {
        id
        status
      }
      title
      type
      raw_type
      raw_status
      submittal_id
      submittal_links_source {
        id
        target_id
      }
      design_reviewer
      design_reviewer_user {
        email
        first_name
        id
        last_name
        project_users {
          status_id
          subscription_vendor {
            name
          }
        }
      }
      gc_reviewer
      gc_reviewer_user {
        email
        first_name
        id
        last_name
        project_users {
          status_id
          subscription {
            organization_subscriptions {
              organization {
                name
              }
            }
          }
        }
      }
      submitter
      submitter_user {
        email
        first_name
        last_name
        id
        project_users {
          status_id
          subscription_vendor {
            name
          }
        }
      }
      responsible_contractor
      responsible_contractor_vendor {
        id
        name
      }
      submittal_status_history_details(order_by: { created_at: desc }) {
        id
        status
        comment
        action
        on_behalf_of
        on_behalf_of_user {
          id
          last_name
          first_name
          email
          project_users {
            subscription_vendor {
              name
            }
          }
          subscription_users {
            subscription {
              name
            }
          }
        }
        created_at
        created_by
        user {
          first_name
          email
          last_name
          id
          project_users {
            subscription_vendor {
              name
            }
          }
          subscription_users {
            subscription {
              name
            }
          }
        }
        assignee
        assignee_user {
          id
          email
          first_name
          last_name
          subscription_users {
            subscription {
              name
            }
          }
          project_users {
            subscription_vendor {
              name
            }
          }
        }
        submittal_revision
        submittal_response_id
        submittal_response {
          id
          key
          response
        }
        assignee_unregistered
        on_behalf_of_unregistered
      }
      submittal_date_block {
        ext_review_offset
        final_gc_review_offset
        gc_review_offset
        submittal_prep_offset
        float
        assigned_date
        ext_review_completed_date
        ext_review_submitted_date
        submittal_distributed_date
        trade_partner_submitted_date
        submittal_id
        actual_assigned_date
        actual_ext_review_completed_date
        actual_ext_review_submitted_date
        actual_submittal_distributed_date
        actual_trade_partner_submitted_date
        manual_entry
        projected_assigned_date
        projected_trade_partner_submitted_date
        projected_ext_review_submitted_date
        projected_ext_review_completed_date
        projected_submittal_distributed_date
      }
      date_block_submittals {
        name_milestone_1
        name_milestone_2
        name_milestone_3
        name_milestone_4
        name_milestone_5
        name_milestone_6
        name_milestone_7
        name_milestone_8
        name_milestone_9
        name_milestone_10
        actual_milestone_1
        actual_milestone_2
        actual_milestone_3
        actual_milestone_4
        actual_milestone_5
        actual_milestone_6
        actual_milestone_7
        actual_milestone_8
        actual_milestone_9
        actual_milestone_10
        name_offset_1
        name_offset_2
        name_offset_3
        name_offset_4
        name_offset_5
        name_offset_6
        name_offset_7
        name_offset_8
        name_offset_9
        name_offset_10
        offset_1
        offset_2
        offset_3
        offset_4
        offset_5
        offset_6
        offset_7
        offset_8
        offset_9
        offset_10
        planned_milestone_1
        planned_milestone_2
        planned_milestone_3
        planned_milestone_4
        planned_milestone_5
        planned_milestone_6
        planned_milestone_7
        planned_milestone_8
        planned_milestone_9
        planned_milestone_10
        projected_milestone_1
        projected_milestone_2
        projected_milestone_3
        projected_milestone_4
        projected_milestone_5
        projected_milestone_6
        projected_milestone_7
        projected_milestone_8
        projected_milestone_9
        projected_milestone_10
        projected_last_milestone_date
        projected_next_milestone_date
        last_milestone_name
        
        manual_entry_date
        actual_float

        pre_WF_start_float
        id
        submittal_id
        project_id

        current_delay
        effective_float
        final_deadline_date
        planned_last_milestone_date
        planned_next_milestone_date
        today_date
        risk_assessment
        risk_level
        low_risk_threshold
        high_risk_threshold
        override_project_threshold
        workflow_status
        wf_override_reason
      }
      submittal_schedule_links {
        task_id
        submittal_id
        driving_task
        linked_to_end_date
        submittal {
          id
          submittal_id
        }
        gantt_task {
          id
          source_task_id
          text
          start_date
          end_date
          critical
          total_slack
          actual_start_date
          actual_finish_date
          progress
          total_slack_computed
        }
      }
      submittal_material_links {
        material_id
        driving_material
        material {
          material_id
          id
          name
          implicit
          actual_ROJ
          actual_fabrication_start_date
          actual_material_release_date
          actual_shipment_date
          material_schedule_links {
            driving_task
            linked_to_end_date
            reverse_dependency
            offset_duration
            linked_offset_date
            gantt_task {
              id
              source_task_id
              text
              start_date
              critical
              total_slack
              actual_start_date
              actual_finish_date
              progress
              total_slack_computed
            }
          }
          material_date_block {
            ROJ_date
            fabrication_duration_offset
            fabrication_start_date
            lead_time_offset
            material_PO_date
            material_PO_fabrication_offset
            on_site_storage_offset
            shipment_date
            material_id
            projected_fabrication_start_date
            projected_material_PO_date
            projected_shipment_date
            projected_ROJ_date
            manual_entry
          }
          date_block_materials {
            name_milestone_1
            name_milestone_2
            name_milestone_3
            name_milestone_4
            name_milestone_5
            name_milestone_6
            name_milestone_7
            name_milestone_8
            name_milestone_9
            name_milestone_10
            actual_milestone_1
            actual_milestone_2
            actual_milestone_3
            actual_milestone_4
            actual_milestone_5
            actual_milestone_6
            actual_milestone_7
            actual_milestone_8
            actual_milestone_9
            actual_milestone_10
            name_offset_1
            name_offset_2
            name_offset_3
            name_offset_4
            name_offset_5
            name_offset_6
            name_offset_7
            name_offset_8
            name_offset_9
            name_offset_10
            offset_1
            offset_2
            offset_3
            offset_4
            offset_5
            offset_6
            offset_7
            offset_8
            offset_9
            offset_10
            planned_milestone_1
            planned_milestone_2
            planned_milestone_3
            planned_milestone_4
            planned_milestone_5
            planned_milestone_6
            planned_milestone_7
            planned_milestone_8
            planned_milestone_9
            planned_milestone_10
            manual_entry_date

            projected_milestone_1
            projected_milestone_2
            projected_milestone_3
            projected_milestone_4
            projected_milestone_5
            projected_milestone_6
            projected_milestone_7
            projected_milestone_8
            projected_milestone_9
            projected_milestone_10

            today_date
            current_delay
            calculation_details
            pre_WF_start_float
            effective_float
            id
            material_id
            final_deadline_date
            risk_assessment
            risk_level
            low_risk_threshold
            high_risk_threshold
            override_project_threshold
            workflow_template_id
            milestone_state
            workflow_status
            wf_override_reason
          }

          spec_section_name
          spec_section_no
          status
          attachments {
            file_name
            id
            blob_key
          }
        }
        material_sequence_id
        material_name
        submittal_id
        submittal_sequence_id
        title
        spec_no
        implicit
      }
      design_reviewer_unregistered
      assignee_unregistered
      design_reviewer_vendor_unregistered
      responsible_contractor_unregistered
      submitter_unregistered

      submittal_participation_from_integrations {
        submittal_participation_type {
          key
        }
        project_integration_user_participant {
          id
          first_name
          last_name
          project_integration_vendor {
            name
          }
        }
        project_integration_vendor_participant {
          id
          name
        }
      }
      spec_section {
        file_key
        specifications {
          latest_processed
        }
      }
      snippet_coordinates
      watchers
      priority
      submittal_number
      deleted_from_source
    }
  }
`;

const FEATURE_ATTACHMENTS = `
  FEATURE_ATTACHMENTS($where: attachments_bool_exp!) {
    attachments(where: { _and: [$where, { uploaded: { _eq: true } }] }) {
      feature_instance_id
      file_name
      file_size
      submittal_id
      material_id
      id
      blob_key
      version
      uploaded
      created_at
      file_type
      reference_id
      submittal_status_history {
        workflow_status
      }
      created_by_user {
        email
        first_name
        last_name
        project_users {
          subscription {
            name
          }
          subscription_vendor {
            name
          }
        }
      }
      versions(where: { uploaded: { _eq: true } }) {
        id
        feature_instance_id
        blob_key
        version
        uploaded
        file_type
        file_name
        created_at
        submittal_id
        submittal_status_history {
          workflow_status
        }
        created_by_user {
          email
          first_name
          last_name
          project_users {
            subscription {
              name
            }
            subscription_vendor {
              name
            }
          }
        }
      }
      on_behalf_of_user_id
      on_behalf_of
      attachments_user {
        first_name
        id
        last_name
        email
      }
    }
  }
`;

const MATERIAL_BY_PK = `
  MaterialByPK($id: uuid!) {
  material_by_pk(id: $id) {
    actual_ROJ
    actual_fabrication_start_date
    actual_material_release_date
    actual_shipment_date
    assignee
    gc_representative
    gc_representative_user {
      first_name
      id
      last_name
      status_id
    }
    id
    material_id
    name
    spec_section_name
    spec_section_no
    spec_section_id
    status
    part_number
    serial_number
    description
    warranty
    manufacturer
    quantity
    material_size
    tag_name
    created_on
    created_by_user {
      email
      first_name
      last_name
    }
    material_quantity_unit {
      measurement
      unit
      id
    }
    material_size_unit {
      id
      measurement
      unit
    }
    assignee_unregistered
    material_assignee {
      first_name
      email
      id
      last_name
      project_users {
        subscription_vendor {
          name
        }
        subscription {
          organization_subscriptions {
            organization {
              name
            }
          }
        }
      }
    }
    trade_partner
    materials_trade_partner {
      name
      id
    }
    material_schedule_links {
      driving_task
      linked_to_end_date
      reverse_dependency
      offset_duration
      linked_offset_date
      gantt_task {
        id
        source_task_id
        text
        start_date
        end_date
        critical
        total_slack
        actual_start_date
        actual_finish_date
        progress
        total_slack_computed
      }
    }
    material_date_block {
      material_id
      ROJ_date
      fabrication_duration_offset
      fabrication_start_date
      lead_time_offset
      material_PO_date
      material_PO_fabrication_offset
      on_site_storage_offset
      shipment_date
      projected_fabrication_start_date
      projected_material_PO_date
      projected_shipment_date
      projected_ROJ_date
      manual_entry
    }
    date_block_materials {
      milestone_state
      name_milestone_1
      name_milestone_2
      name_milestone_3
      name_milestone_4
      name_milestone_5
      name_milestone_6
      name_milestone_7
      name_milestone_8
      name_milestone_9
      name_milestone_10
      actual_milestone_1
      actual_milestone_2
      actual_milestone_3
      actual_milestone_4
      actual_milestone_5
      actual_milestone_6
      actual_milestone_7
      actual_milestone_8
      actual_milestone_9
      actual_milestone_10
      name_offset_1
      name_offset_2
      name_offset_3
      name_offset_4
      name_offset_5
      name_offset_6
      name_offset_7
      name_offset_8
      name_offset_9
      name_offset_10
      offset_1
      offset_2
      offset_3
      offset_4
      offset_5
      offset_6
      offset_7
      offset_8
      offset_9
      offset_10
      planned_milestone_1
      planned_milestone_2
      planned_milestone_3
      planned_milestone_4
      planned_milestone_5
      planned_milestone_6
      planned_milestone_7
      planned_milestone_8
      planned_milestone_9
      planned_milestone_10
      projected_milestone_1
      projected_milestone_2
      projected_milestone_3
      projected_milestone_4
      projected_milestone_5
      projected_milestone_6
      projected_milestone_7
      projected_milestone_8
      projected_milestone_9
      projected_milestone_10
      projected_last_milestone_date
      projected_next_milestone_date
      current_delay
      manual_entry_date
      actual_float
      pre_WF_start_float
      id
      material_id
      calculation_details
      effective_float
      final_deadline_date
      planned_last_milestone_date
      planned_next_milestone_date
      today_date
      risk_assessment
      risk_level
      low_risk_threshold
      high_risk_threshold
      override_project_threshold
      workflow_template_id
      workflow_status
      wf_override_reason
    }
    submittal_material_links {
      submittal_id
      submittal {
        deleted_from_source
        submittal_id
        title
        id
        submittal_status_history_details(order_by: {created_at: desc}) {
          status
        }
        submittal_material_links {
          driving_material
          material_sequence_id
          material_name
        }
        submittal_schedule_links {
          linked_to_end_date
          driving_task
          gantt_task {
            id
            source_task_id
            text
            critical
            total_slack
            actual_start_date
            actual_finish_date
            progress
            total_slack_computed
          }
        }
        submittal_date_block {
          submittal_id
          actual_assigned_date
          actual_ext_review_completed_date
          actual_ext_review_submitted_date
          actual_submittal_distributed_date
          actual_trade_partner_submitted_date
          assigned_date
          ext_review_completed_date
          ext_review_offset
          ext_review_submitted_date
          final_gc_review_offset
          float
          gc_review_offset
          submittal_distributed_date
          submittal_prep_offset
          trade_partner_submitted_date
          manual_entry
          projected_assigned_date
          projected_trade_partner_submitted_date
          projected_ext_review_submitted_date
          projected_ext_review_completed_date
          projected_submittal_distributed_date
        }
        date_block_submittals {
          name_milestone_1
          name_milestone_2
          name_milestone_3
          name_milestone_4
          name_milestone_5
          name_milestone_6
          name_milestone_7
          name_milestone_8
          name_milestone_9
          name_milestone_10
          actual_milestone_1
          actual_milestone_2
          actual_milestone_3
          actual_milestone_4
          actual_milestone_5
          actual_milestone_6
          actual_milestone_7
          actual_milestone_8
          actual_milestone_9
          actual_milestone_10
          name_offset_1
          name_offset_3
          name_offset_4
          name_offset_5
          name_offset_6
          name_offset_7
          name_offset_8
          name_offset_9
          name_offset_10
          offset_1
          offset_2
          offset_3
          offset_4
          offset_5
          offset_6
          offset_7
          offset_8
          offset_9
          offset_10
          planned_milestone_1
          planned_milestone_2
          planned_milestone_3
          planned_milestone_4
          planned_milestone_5
          planned_milestone_6
          planned_milestone_7
          planned_milestone_8
          planned_milestone_9
          planned_milestone_10
          manual_entry_date
          projected_milestone_1
          projected_milestone_2
          projected_milestone_3
          projected_milestone_4
          projected_milestone_5
          projected_milestone_6
          projected_milestone_7
          projected_milestone_8
          projected_milestone_9
          projected_milestone_10
          today_date
          current_delay
          calculation_details
          pre_WF_start_float
          effective_float
          final_deadline_date
          id
          submittal_id
          risk_assessment
          risk_level
          low_risk_threshold
          high_risk_threshold
          override_project_threshold
          workflow_status
          wf_override_reason
          name_offset_2
        }
        status
        workflow_status
        submittals_status {
          id
          status
        }
        submittal_attachments {
          version_of
          submittal_revision
          file_name
          id
        }
        revision
        spec_section_id
        spec_no
        spec_name
        type
      }
      material_id
      material_sequence_id
      material_name
      submittal_id
      submittal_sequence_id
      title
      spec_no
    }
    place_id
    material_project_location {
      id
      location_service_id
      location_service {
        label
        municipality
        sub_region
        region
        country
      }
    }
    feature_locations {
      location {
        name
        id
        path
      }
    }
    purchase_order
  }
}
`;

const SUBMITTAL_LIST_WF = `
  SubmittalList {
    submittal_list_wf_mode_func(order_by: { id: asc }) {
      actual_assigned_date
      actual_ext_review_completed_date
      actual_ext_review_submitted_date
      actual_submittal_distributed_date
      actual_trade_partner_submitted_date
      assignee_unregistered
      assignee_user_id
      attachment_count
      assignee_status
      gc_reviewer_status
      submitter_status
      design_reviewer_status
      created_by
      description
      design_reviewer_unregistered
      design_reviewer_user_id
      gc_reviewer_user_id
      history
      id
      materials
      planned_ext_review_completed_date
      planned_submittal_distributed_date
      planned_trade_partner_submitted_date
      project_id
      responsible_contractor_id
      responsible_contractor_name
      responsible_contractor_unregistered
      revision
      snippet_coordinates
      snippet_file_key
      spec_name
      spec_no
      state
      state_numeric
      submittal_sequence_id
      submitter_unregistered
      submitter_user_id
      tasks
      title
      type
      workflow_status
      spec_section_file_key
      snippet_coordinates
      next_planned_deadline
      next_action
      due_date
      risk_level
      priority
      watchers
      created_at
      float
      date_block_data
      submittal_number
    }
  }
`;

const SUBMITTAL_LIST_INTG = `
  SubmittalList {
    submittal_list_intg_mode_func(order_by: { id: asc }) {
      actual_assigned_date
      actual_ext_review_completed_date
      actual_ext_review_submitted_date
      actual_submittal_distributed_date
      actual_trade_partner_submitted_date
      assignee_unregistered
      assignee_user_id
      attachment_count
      assignee_status
      gc_reviewer_status
      submitter_status
      design_reviewer_status
      created_by
      description
      design_reviewer_unregistered
      design_reviewer_user_id
      gc_reviewer_user_id
      history
      id
      materials
      planned_ext_review_completed_date
      planned_submittal_distributed_date
      planned_trade_partner_submitted_date
      project_id
      responsible_contractor_id
      responsible_contractor_name
      responsible_contractor_unregistered
      revision
      snippet_coordinates
      snippet_file_key
      spec_name
      spec_no
      state
      state_numeric
      submittal_sequence_id
      submitter_unregistered
      submitter_user_id
      tasks
      title
      type
      workflow_status
      revision_date_blocks
      spec_section_file_key
      snippet_coordinates
      next_planned_deadline
      next_action
      due_date
      risk_level
      priority
      watchers
      created_at
      float
      date_block_data
      submittal_number
    }
  }
`;

const MATERIAL_LIST = `
ProjectMaterials {
  material_list_func(where: { implicit: { _neq: true } }, order_by: {id: asc}) {
    id
    material_id
    name
    spec_section_no
    spec_section_name
    description
    trade_partner
    trade_partner_name
    assignee
    assignee_unregistered
    assignee_first_name
    assignee_last_name
    assignee_organization_name
    assignee_vendor_name
    gc_representative
    gc_representative_first_name
    gc_representative_last_name
    actual_ROJ
    actual_fabrication_start_date
    actual_material_release_date
    actual_shipment_date
    planned_ROJ
    tasks
    submittals
    material_tag
    status
    delta
    quantity
    quantity_unit
    material_PO_fabrication_offset
    fabrication_duration_offset
    lead_time_offset
    on_site_storage_offset
    material_size
    material_size_unit
    manufacturer
    serial_number
    part_number
    warranty
    next_planned_deadline
    next_action
    due_date
    risk_level
    created_at
    date_block_template_name
    date_block_template_id
    float
    assignee_status
    project_engineer_status
    gc_representative_status
    date_block_data
  }
}
`;

const SUBSCRIPTION_INTEGRATIONS = `
Integrations {
  integrations {
    system
    id
    availability_status
  }
}
`;

const SUBSCRIPTION_INTG_CONFIGS = `
SubscriptionIntegrationConfigs {
  subscription_integration_configs {
    id
    config_id
    active
    subscription_id
        integration_config {
      id
      integration_config_properties {
        property_name
        property_value
        id
      }
    }
    system_integration_config {
      integration {
      system
      availability_status
      id
    }
      integration_config {
      id
      integration_config_properties {
        property_name
        property_value
        id
          }
    }
  }
  }
}
`;

const PROJECT_INTG_CONFIGS = `
ProjectIntegrationConfigs {
  project_integration_configs {
    id
    config_id
    active
    subscription_integration_config_id
    subscription_integration_config {
      config_id
      integration_config {
        integration_config_properties {
          property_name
          property_value
        }
      }
    }
    integration_config {
      id
      integration_config_properties {
        property_name
        property_value
        id
      }
    }
    system_integration_config {
      integration {
      system
      availability_status
      id
      }
      integration_config {
      id
      integration_config_properties {
        property_name
        property_value
        id
          }
    }
     
      subscription_integration_configs {
        integration_config {
          id
          integration_config_properties {
            id
            property_name
            property_value
          }
        }
      }
    }
    
    
  }
}
`;

const OAUTH_OUTPUT = `
GetOauthOutput($id: uuid!) {
  oauth_operations(where: {id: {_eq: $id}}) {
    operation_type
    source_type
    created_by_user {
      email
      first_name
      last_name
      id
    }
    oauth_status {
      status
      id
    }
    updated_at
    output
  }
}
`;

const COLUMN_HEADERS = `
  ColumnHeaders {
    project_feature_configurations {
      feature_id
      field_mapping
      float
      project_id
    }
  }
`;

const DATEBLOCK_ACTIONS = `
  DateBlockActions($where: project_feature_configurations_bool_exp = {}) {
    project_feature_configurations (where: $where){
      feature_id
      date_block_action
    }
  }
`;
const GET_SPECIFICATIONS = `
GetSpecifications {
  specifications(where: {status: {_in: ["PROCESSED", "PROCESSING"]}, version_of: {_is_null: true}}) {
    id
    title
    status
    version_of
    version_name
    version_date
    created_at
    created_by_user {
      email
      first_name
      last_name
    }
    spec_text_analysis_stat {
      spec_file_key
    }
    child_specifications(where: {status: {_in: ["PROCESSED", "PROCESSING"]}}) {
      id
      title
      status
      version_of
      version_name
      version_date
      created_at
      created_by_user {
        email
        first_name
        last_name
      }
      parent_specification {
        id
      }
      spec_text_analysis_stat {
        spec_file_key
      }
    }
  }
}
`;

const GET_SUBMITTAL_INSIGHTS = `
GetSubmittalInsights($where: submittal_insights_view_bool_exp) {
  submittal_insights_view(where: $where) {
    title
    project_name
    spec_section_name
    spec_section_number
    responsible_contractor_name
    submittal_prep_time
    design_review_time
    total_workflow_time
    total_revisions
    submittal_type
  }
  }
`;

const PROJECT_INSIGHTS_CONFIG = `
  ProjectInsightsConfig {
    project_feature_configurations {
      feature_id
      insights_enabled
    }
  }
`;

const GET_COMMENTS = `
GetComments($where: comment_bool_exp) {
  comment(where: $where, order_by: {created_at: desc}) {
    id
    description
    attachments(where: { uploaded: { _eq: true } }) {
      id
      file_name
      file_type
      file_size
      blob_key
    }
    workflow_step
    workflow_template_id
    created_at
    created_by
    created_by_user {
      email
      first_name
      last_name
      project_users {
        subscription {
          name
        }
      }
    }
  }
}
`;

const GET_PROJECT_WORKFLOW_TEMPLATE_NAMES = `GetProjectWorkflowTemplates($featureId: Int!) {
  project_workflow_templates(where: {feature_id: {_eq: $featureId}, disabled: {_eq: false}}) {
    name
    id
    default
    dateblock_compute_strategy {
      key
      name
      description
    }
  }
}`;

const GET_MDB_TEMPLATES = `
  GetMDBTemplates {
    project_workflow_templates(where: {feature_id: {_eq: 2}}) {
      id
      name
      default
      disabled
      feature_id
      additional_offset
      float
      project_template_milestones(order_by: {sequence_no: asc}) {
        id
        sequence_no
        name
        milestone_action
        next_offset {
          name
          id
          duration
        }
      }
      updated_by
      updated_by_user {
        first_name
        email
        last_name
        id
      }
      updated_at
      created_by_user {
        email
        first_name
        last_name
      }
      created_at
      date_blocks_aggregate(where: {workflow_status: {_eq: "IN_PROGRESS"}}) {
        aggregate {
          count
        }
      }
    }
  }
`;

const GET_PROJECT_DB_TEMPLATES = `
  GetProjectDBTemplates($featureId: Int!) {
    project_workflow_templates(where: {feature_id: {_eq: $featureId}}) {
      id
      name
      default
      disabled
      feature_id
      feature {
        show_float
      }
      additional_offset
      float
      project_template_milestones(order_by: {sequence_no: asc}) {
        id
        sequence_no
        name
        milestone_action
        next_offset {
          name
          id
          duration
        }
      }
      updated_by
      updated_by_user {
        first_name
        email
        last_name
        id
      }
      updated_at
      created_by_user {
        email
        first_name
        last_name
      }
      created_at
      date_blocks_aggregate(where: {workflow_status: {_eq: "IN_PROGRESS"}}) {
        aggregate {
          count
        }
      }
      feature_workflow_instances_aggregate(where: {workflow_status: {_in: ["IN_PROGRESS", "WF_COMPLETED"]}}) {
        aggregate {
          count
        }
      }
      dateblock_compute_strategy {
        key
        name
        description
      }
    }
  }
`;

const SYSTEM_INTEGRATION_CONFIGS = `
SystemIntegrationConfig {
  system_integration_configs {
    integration {
      system
    }
    integration_config {
      integration_config_properties {
        property_name
        property_value
      }
    }
}
}`;

const INTEGRATION_IMPORT_LOGS = `
IntegrationImportLog {
  import_log(limit: 1, order_by: {created_at: desc}, where: {_and: {status: {_in: ["PROCESSED", "PROCESSING", "FAILED"]}, import_type: {_in: [ACC_IMPORT, BIM360_IMPORT, PROCORE_IMPORT, INTEGRATION_FILE_IMPORT]}}}) {
    metadata
    status
    id
  }
}`;

const GET_DB_SUBSCRIPTION_TEMPLATES = `
  GetDBTemplates($feature_id: Int!) {
    subscription_workflow_templates(where: {feature_id: {_eq: $feature_id}}) {
      id
      name
      default
      disabled
      feature_id
      feature {
        show_float
      }
      additional_offset
      float
      updated_by
      updated_by_user {
        first_name
        email
        last_name
        id
      }
      updated_at  
      created_by_user {
        email
        first_name
        last_name
      }
      created_at  
      subscription_template_milestones(order_by: {sequence_no: asc}) {
         id
          sequence_no
          name
          milestone_action
          next_offset {
            name
            id
            duration
          }        
      }
      dateblock_compute_strategy {
        key
        name
        description
      }
    }
  }
`;

const GET_PROJECT_FEATURE_CONFIGURATION = `
  GetProjectFeatureConfiguration {
    project_feature_configurations {
      feature_id
      high_risk_threshold
      low_risk_threshold
    }
  }
`;

const GET_MATERIAL_CHANGELOG_CONFIG = `
  getMaterialChangelogconfig($project_id: uuid!, $user_id: uuid!) {
    project_users(
      where: {
        _and: [
          { project_id: { _eq: $project_id } }
          { user_id: { _eq: $user_id } }
        ]
      }
    ) {
      material_changelog_config
    }
  }
`;

const GET_FEATURES_DATA_BY_IDS_FOR_REQUEST_DURATION = `
  GetFeatureDataByIdsForRequestDuration($featureIds: [uuid!]!) {
    feature_instance(where: {id: {_in: $featureIds}}) {
    id
    name: title
    material_assignee: feature_user_paticipants(
      where: {user_participation_type_id: {_eq: 1}}
    ) {
      user_unregistered
      user {
        id
        email
        first_name
        last_name
        project_users {
          status {
            id
            name
          }
        }
      }
    }
    estimate_invite_features(order_by: {estimated_invite: {created_at: desc}}) {
      estimated_invite {
        delivery_status
        notes
        created_at
      }
    }
    materials_trade_partner: feature_company_participants(
      where: {company_participation_type_id: {_eq: 1}}
    ) {
      vendor {
        name
        id
      }
    }
    feature_materials {
      assignee_unregistered
      status
    }
    feature_workflow_instance {
      workflow_status
      milestone_state
      project_workflow_template {
        dateblock_compute_strategy {
          key
          name
          description
        }
      }
    }
  }
  }
`;

const GET_NOTIFICATION_SCHEDULES = `
  GetNotificationSchedules {
    notification_schedules(where: {notification_type: {_eq: UPCOMING_MILESTONES}}, order_by: {updated_at: desc}) {
    id
    schedule_input
    enabled
    notification_schedule_recipients {
      distribution_group {
        id
        name
      }
      user {
        email
        first_name
        id
        last_name
      }
    }
    updated_at
    created_at
  }
  }
`;

const GET_SCHEDULE_VERSIONS = `
   ScheduleVersions {
    schedule_import_details(
      order_by: { created_at: desc }
      where: { import_log: { import_type: { _eq: SCHEDULE } } }
    ) {
      id
      import_log_id
      is_active
      schedule_name
      schedule_date
      schedule_type
      activated_at
      created_at
      import_log {
        id
        resolved_values_s3_prefix
        source_values_s3_prefix
        created_at
        created_by_user {
          id
          first_name
          last_name
        }
      }
    }
  }
`;

const SUBSCRIPTION_LEVEL_COMPANY_LIST = `
  CompanyList($where: subscription_vendors_bool_exp = {}) {
    subscription_vendors(where: $where, order_by: { name: asc }) {
      id
      name
      address
      external_source_id
      trade_partner_pocs(where: { deleted: { _eq: false } }) {
        email
        first_name
        last_name
        phone
        id
      }
      vendor_source_infos {
        full_source_name
      }
    }
  }
`;

const GET_ALL_LOCATIONS = gql`
  query GetAllLocations {
    get_locations_with_paths {
      path
      name
      id
    }
  }
`;

const QUERY_GET_ENTITY_COUNT_V2 = gql`
  query GetEntityCount {
    submittals_aggregate: feature_instance_aggregate(
      where: {
        deleted: { _eq: false }
        deleted_from_source: { _eq: false }
        feature_type_id: { _eq: 1 }
        is_tracked: { _eq: true }
        feature_submittals: { workflow_status: { _neq: 8 } }
      }
    ) {
      aggregate {
        count
      }
    }
    material_aggregate: feature_instance_aggregate(
      where: {
        implicit: { _eq: false }
        deleted: { _eq: false }
        feature_type_id: { _eq: 2 }
      }
    ) {
      aggregate {
        count
      }
    }
    schedule_import_details {
      id
    }
  }
`;

// Precon module counts for the dashboard navbar: 5 = Design Package,
// 10 = Design Scope, 4 = Bid Package.
const QUERY_GET_PRECON_ENTITY_COUNT = gql`
  query GetPreconEntityCount {
    design_package_aggregate: feature_instance_aggregate(
      where: { deleted: { _eq: false }, feature_type_id: { _eq: 5 } }
    ) {
      aggregate {
        count
      }
    }
    design_scope_aggregate: feature_instance_aggregate(
      where: { deleted: { _eq: false }, feature_type_id: { _eq: 10 } }
    ) {
      aggregate {
        count
      }
    }
    bid_package_aggregate: feature_instance_aggregate(
      where: { deleted: { _eq: false }, feature_type_id: { _eq: 4 } }
    ) {
      aggregate {
        count
      }
    }
  }
`;

const QUERY_SUBMITTAL_CATEGORY_COUNTS = gql`
  query SubmittalCategoryCounts {
    tracked: feature_submittals_aggregate(
      where: {
        status: { _neq: 11 }
        feature_instance: {
          feature_type_id: { _eq: 1 }
          is_tracked: { _eq: true }
          deleted: { _eq: false }
          deleted_from_source: { _eq: false }
        }
      }
    ) {
      aggregate {
        count
      }
    }

    untracked: feature_submittals_aggregate(
      where: {
        status: { _neq: 11 }
        feature_instance: {
          feature_type_id: { _eq: 1 }
          is_tracked: { _eq: false }
          deleted: { _eq: false }
          deleted_from_source: { _eq: false }
        }
      }
    ) {
      aggregate {
        count
      }
    }

    void: feature_submittals_aggregate(
      where: {
        status: { _eq: 11 }
        feature_instance: {
          feature_type_id: { _eq: 1 }
          deleted: { _eq: false }
          deleted_from_source: { _eq: false }
        }
      }
    ) {
      aggregate {
        count
      }
    }

    deleted_from_source: feature_submittals_aggregate(
      where: {
        feature_instance: {
          feature_type_id: { _eq: 1 }
          deleted: { _eq: false }
          deleted_from_source: { _eq: true }
        }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

const QUERY_SUBSCRIPTION_USERS = gql`
  query QUERY_SUBSCRIPTION_USERS {
    subscription_users {
      user_id
      user {
        id
        first_name
        last_name
        email
        phone
        status {
          id
          name
        }
      }
      subscription_permission_id
      subscription_permission {
        name
      }
      subscription {
        organization_subscriptions {
          organization {
            name
            id
          }
        }
      }
      status_id
      vendor_id
      external_source_id
      subscription_vendor {
        id
        name
      }
      user_source_infos {
        full_source_name
      }
    }
  }
`;

const QUERY_USER_SUBSCRIPTION_ROLES = gql`
  query UserSubscriptionRole($where: subscription_permission_bool_exp = {}) {
    subscription_permission(where: $where) {
      id
      name
      key
    }
  }
`;

const QUERY_GET_INTEGRATION_PROJECT_COUNT = gql`
  query QUERY_GET_INTEGRATION_PROJECT_COUNT {
    project(where: { mode: { _eq: 2 } }, limit: 1) {
      id
    }
  }
`;

const QUERY_GET_FEATURE_FLAGS = gql`
  query GET_FEATURE_FLAGS($orgId: uuid!) {
    subscription(
      where: {
        organization_subscriptions: { organization_id: { _eq: $orgId } }
      }
    ) {
      id
      name
      projects_owned(where: { deleted: { _eq: false } }) {
        id
        name
        project_product_entitlements {
          enabled
          product_entitlement {
            id
            feature
          }
        }
      }
      subscription_product_entitlements(
        where: { product_entitlement_id: { _in: [17, 18, 35] } }
      ) {
        enabled
        product_entitlement {
          id
          feature
        }
      }
      future_projects_entitlements: subscription_product_entitlements {
        enable_for_future_projects
        product_entitlement {
          id
          feature
        }
      }
    }
  }
`;

const QUERY_PROJECT_ROLES = gql`
  query ProjectRole($where: project_role_bool_exp) {
    project_role(where: $where) {
      id
      name
      type_id
      key
    }
  }
`;

const QUERY_PROJECT_COMPANY_LIST = gql`
  query ProjectCompanyListQuery {
    project_vendors {
      vendor_id
      type_id
      subscription_vendor {
        name
        id
      }
    }
  }
`;

const QUERY_GET_AUDIT_LOGS = gql`
  query getAuditLog($filter_criteria: FilterCriteria!) {
    get_audit_logs(filter_criteria: $filter_criteria) {
      category
      date
      event_type
      file_name
      module
      project_name
      user
      email
    }
  }
`;

export {
  SUBMITTAL_BY_PK,
  FEATURE_ATTACHMENTS,
  MATERIAL_BY_PK,
  SUBMITTAL_LIST_WF,
  MATERIAL_LIST,
  SUBSCRIPTION_INTG_CONFIGS,
  SUBSCRIPTION_INTEGRATIONS,
  OAUTH_OUTPUT,
  PROJECT_INTG_CONFIGS,
  COLUMN_HEADERS,
  SUBMITTAL_LIST_INTG,
  GET_SPECIFICATIONS,
  GET_SUBMITTAL_INSIGHTS,
  PROJECT_INSIGHTS_CONFIG,
  GET_COMMENTS,
  DATEBLOCK_ACTIONS,
  GET_MDB_TEMPLATES,
  GET_PROJECT_DB_TEMPLATES,
  GET_PROJECT_WORKFLOW_TEMPLATE_NAMES,
  SYSTEM_INTEGRATION_CONFIGS,
  INTEGRATION_IMPORT_LOGS,
  GET_DB_SUBSCRIPTION_TEMPLATES,
  GET_PROJECT_FEATURE_CONFIGURATION,
  GET_MATERIAL_CHANGELOG_CONFIG,
  GET_NOTIFICATION_SCHEDULES,
  GET_SCHEDULE_VERSIONS,
  SUBSCRIPTION_LEVEL_COMPANY_LIST,
  GET_ALL_LOCATIONS,
  QUERY_GET_ENTITY_COUNT_V2,
  QUERY_GET_PRECON_ENTITY_COUNT,
  QUERY_SUBMITTAL_CATEGORY_COUNTS,
  GET_FEATURES_DATA_BY_IDS_FOR_REQUEST_DURATION,
  QUERY_SUBSCRIPTION_USERS,
  QUERY_USER_SUBSCRIPTION_ROLES,
  QUERY_GET_INTEGRATION_PROJECT_COUNT,
  QUERY_GET_FEATURE_FLAGS,
  QUERY_PROJECT_ROLES,
  QUERY_PROJECT_COMPANY_LIST,
  QUERY_GET_AUDIT_LOGS
};
